import React from 'react';
import Tooltip from '../Tooltip';

interface EllipsisTextProps {
  text: string;
  className?: string;
  onClick?: () => void;
  hideTooltip?: boolean;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({ text, className, onClick, hideTooltip }) => {
  const [isOverflowing, setIsOverflowing] = React.useState(false);
  const textRef = React.useRef<HTMLSpanElement>(null);
  const hiddenTextRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && hiddenTextRef.current) {
        const visibleWidth = textRef.current.offsetWidth;
        const fullTextWidth = hiddenTextRef.current.offsetWidth;
        setIsOverflowing(fullTextWidth + 10 > visibleWidth);
      }
    };

    const resizeObserver = new ResizeObserver(checkOverflow);
    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    checkOverflow();

    return () => {
      resizeObserver.disconnect();
    };
  }, [text]);

  return (
    <>
      <Tooltip title={isOverflowing ? text : undefined} placement="top" hide={hideTooltip}>
        <span
          ref={textRef}
          className={`title-ellipsis-styles ${className || ''}`}
          onClick={onClick}
        >
          {text}
        </span>
      </Tooltip>
      <span ref={hiddenTextRef} className="referrence-element">
        {text}
      </span>
    </>
  );
};

export default EllipsisText;
